/* eslint-disable camelcase */
import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {SiteConfigContext} from '@homeaway/gatsby-theme-vrbo/src/context/SiteConfigContext';
import {checkIfIsSingaporeButNotEnglish, getSlug} from '../../utils';
import {Link} from 'gatsby';

/**
 * Note: this logic emulates what we're doing in
 * createResolvers in gatsby-node.js (21-36)
 * If updates get made, we must make them in both places!
 */
export default function LocalizedLink({locale, slug, children}) {
    const {sitename} = useContext(SiteConfigContext);
    const withLocale = checkIfIsSingaporeButNotEnglish(sitename, locale);
    const to = withLocale ? `/${getSlug(locale)}/${slug}` : `/${slug}`;
    return <Link to={to}>{children}</Link>;
}

LocalizedLink.propTypes = {
    /* contentful locale */
    locale: PropTypes.string.isRequired,
    /* simple page slug */
    slug: PropTypes.string.isRequired,
};
